module.exports = __webpack_public_path__ + "static/media/icon-typescript.1097a612.svg";